export default __webpack_public_path__ + "static/communicate-582d8047b2ad94488a82a76bc846ffd0.png";